import { QuickSearchViewModel } from 'autogen/swagger/all';
import Routes from 'modules/routes';

let lastFetchedController: AbortController | null = null;

export default async function searchProducts(searchString: string): Promise<QuickSearchViewModel> {
    if (lastFetchedController) {
        lastFetchedController.abort();
    }
    const controller = new AbortController();
    const { signal } = controller;
    let url = Routes.Search.QuickSearch + encodeURIComponent(searchString);
    url = `${url}&sections=products`;

    return (
        fetch(url, { signal })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Failed to fetch JSON from: ${url}`);
                }
                lastFetchedController = null;

                return res.json() as Promise<QuickSearchViewModel>;
            })
            // eslint-disable-next-line consistent-return
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error(err);
                    return null;
                }
            })
    );
}
